module.exports = __webpack_public_path__ + "52c1eb0cdd88cdb268e9f91c0f473c7c.png";